import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-section">
      <div className="about-us-content">
        <div className="about-us-text">
          <h2 className="about-us-title">About Us</h2>
          <p className="about-us-description">
            We are a team of veteran software developers and marketers, with combined 10+ years of experience, who help restaurants grow their online ordering. 
            From custom ordering platforms to seamless payment integrations, we build solutions that turn your digital presence into a revenue-generating powerhouse. 
            Our expertise spans across mobile apps, web platforms, and backend systems that handle thousands of orders daily. 
            We understand the unique challenges restaurants face in today's digital landscape. 
          </p>
        </div>
        
        <div className="about-us-illustration">
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
